import { __assign } from "tslib";
import { useEffect, useMemo, useRef } from 'react';
import { useRouterSource } from './useRouterSource';
export function useRouterService(routerService, options) {
    if (options === void 0) { options = {}; }
    var onResponseComplete = options.onResponseComplete, transitionTimeoutMs = options.transitionTimeoutMs, unstable_isConcurrent = options.unstable_isConcurrent;
    var source = routerService[0], routerController = routerService[1];
    var _a = useRouterSource(source, {
        transitionTimeoutMs: transitionTimeoutMs,
        unstable_isConcurrent: unstable_isConcurrent,
    }), _b = _a[0], content = _b.content, request = _b.request, response = _b.response, pending = _a[1], waitUntilNavigationCompletes = _a[2];
    var onResponseCompleteRef = useRef(onResponseComplete);
    useEffect(function () {
        onResponseCompleteRef.current = onResponseComplete;
    }, [onResponseComplete]);
    useEffect(function () {
        waitUntilNavigationCompletes().then(function (snapshot) {
            var handler = onResponseCompleteRef.current;
            if (handler && snapshot.request === request) {
                handler(snapshot.response, snapshot.request);
            }
        });
    }, [request, response, waitUntilNavigationCompletes]);
    return useMemo(function () { return (__assign(__assign({}, routerController), { content: content, navigate: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return routerController
                .navigate.apply(routerController, args).then(function (navigated) {
                return navigated ? waitUntilNavigationCompletes().then(function () { return true; }) : false;
            });
        }, pending: pending,
        request: request,
        waitUntilNavigationCompletes: waitUntilNavigationCompletes })); }, [content, routerController, pending, request, waitUntilNavigationCompletes]);
}
